import React from "react";
import "./ArticleHeader.css";

const ArticleHeader = ({ category, date, title, image }) => {
  return (
    <header className="article-header">
      <div className="article-header__meta">
        <span className="article-header__tag">{category}</span>
        <span className="article-header__dot" aria-hidden="true" />
        <time className="article-header__date">{date}</time>
      </div>
      <h1 className="article-header__title">{title}</h1>
      <img src={image} alt="" className="article-header__image" />
    </header>
  );
};

export default ArticleHeader;
